import { React, useState, useEffect } from "react";
import history from "../../routes/history";
import ProgressBar from "../ProgressBar/ProgressBar";
import BottomButtons from "../bottom-buttons/BottomButtons";
import { Input } from "antd";
import ReactQuill from "react-quill";
import "./message.css";
import { useDispatch, useSelector } from "react-redux";
import { candidateDetailSuccess } from "../../redux/actions";
import { addCandidateProfileApi } from "../../API/API";

const MessageToCandidate = () => {
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );
  const [message, setMessage] = useState(
    getInputValues?.messageToCandidate || ""
  );
  const [charCount, setCharCount] = useState(0);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const charLimit = 150;
  useEffect(() => {
    setMessage(getInputValues?.messageToCandidate || "");
  }, [getInputValues]);

  const nextHandler = async () => {
    try {
      setLoading(true);
      const modifiedValue = text.replace(/<p>|<\/p>|<br\s*\/?>/g, "");
      if (modifiedValue?.length) {
        dispatch(
          candidateDetailSuccess({
            ...getInputValues,
            messageToCandidate: modifiedValue,
          })
        );
        const { title=undefined, pay=undefined, skillListing={}, ...rest } = getInputValues;
        const response = await addCandidateProfileApi({
          ...rest,
          skillListing: { ...skillListing, title, pay },
          messageToCandidate: modifiedValue,
        });
        if (response.status == 200) {
          localStorage.setItem("candidateName",getInputValues.name)
          history.push("/employerdashboard")
         
        }
        else {
          throw response?.msg || "Failed to add Candidate";
        }
      } else {
        setError(true);
        setErrorMessage("Please write a message");
      }
    } catch (error) {
      console.warn("error", error.errorMessage, error);
      const _error = error == "string" ? error : "Something went wrong";
      setError(true);
      setErrorMessage(_error);
    } finally {
      setLoading(false);
    }
  };

  const backHandler = () => {
    history.push("/date");
  };

  const handleTextChange = (value) => {
    setError(false);
    const strippedText = value.replace(/<[^>]+>/g, "");
    if (strippedText.length > charLimit) {
      const truncatedText = strippedText.substring(0, charLimit);
      setText(truncatedText);
      setCharCount(charLimit);
    } else {
      setText(value);
      setCharCount(strippedText.length);
    }
  };
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["clean"],
    ],
  };

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar
          heading={"Candidate message"}
          percent={100}
        />
        <div className="email-text">
          Message to candidate
          <div className="email-mandatory">(Mandatory)</div>
        </div>
        <div className={`editor-container ${error ? "error-border" : ""}`}>
          <ReactQuill
            className="reactQuill"
            value={text}
            onChange={handleTextChange}
            placeholder="ex. Hi (Candidate name), join the private marketplace for further process."
            modules={modules}
          />
        </div>

        <div className="char-counter">
          <div>
            {error && (
              <div className="error-msg-content1">
                {/* <img src={errorIcon} alt="" /> */}
                <span className="errortext">{errorMessage} </span>
              </div>
            )}
          </div>
          <div>
            {charCount}/{charLimit}
          </div>
        </div>
        <div>
          <BottomButtons
            text="Send Invite"
            nextHandler={nextHandler}
            backHandler={backHandler}
            nextBtnLoading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default MessageToCandidate;
